import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export const useNotificationFrequencyOptions = () => {
  const { t } = useTranslation('common');
  return useMemo(
    () => [
      {
        id: 'every_job_position',
        key: 'every_job_position',
        label: t('as_soon_as_there_is_a_job_position'),
      },
      {
        id: 'weekly',
        key: 'weekly',
        label: t('every_week'),
      },
      {
        id: 'biweekly',
        key: 'biweekly',
        label: t('every2_weeks'),
      },
      {
        id: 'monthly',
        key: 'monthly',
        label: t('every_month'),
      },
    ],
    [t]
  );
};
